
import { computed, defineComponent, PropType, reactive, toRaw } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { StoryT } from '@/core/types/stories.types'

// realisations
import { stories } from '@/core/realisations/stories.realisation'

// constants
import { VISIBILITY_TYPES } from '@/core/constants/stories.constants'

export default defineComponent({
    components: {
        cheap: Cheap,
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<StoryT>,
            default: null,
        },
    },
    emits: ['update', 'published', 'unpublished', 'deleted'],
    setup(props, { emit }) {
        const state = reactive({
            is_changing_status: false,
            is_deleting: false,
        })

        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const publishStory = async () => {
            const answer = confirm(
                `Вы действительно хотите опубликовать историю '${props.item.name}'?`
            )
            if (!answer) return

            try {
                state.is_changing_status = true
                await stories.publishStory(props.item.id)
                emit('published')
            } catch (error) {
                console.error(error)
            } finally {
                state.is_changing_status = false
            }
        }

        const unpublishStory = async () => {
            const answer = confirm(
                `Вы действительно хотите снять с публикации историю '${props.item.name}'?`
            )
            if (!answer) return

            try {
                state.is_changing_status = true
                await stories.unpublishStory(props.item.id)
                emit('unpublished')
            } catch (error) {
                console.error(error)
            } finally {
                state.is_changing_status = false
            }
        }

        const deleteStory = async () => {
            const answer = confirm(`Вы действительно хотите удалить историю '${props.item.name}'?`)
            if (!answer) return

            try {
                state.is_deleting = true
                await stories.deleteStory(props.item.id)
                emit('deleted')
            } catch (error) {
                console.error(error)
            } finally {
                state.is_deleting = false
            }
        }

        const getVisibilityType = computed(
            () => VISIBILITY_TYPES.find((type) => type.id === props.item.visibility_type)?.name
        )

        return {
            state,
            emitUpdate,
            publishStory,
            unpublishStory,
            deleteStory,
            //
            VISIBILITY_TYPES,
            //
            getVisibilityType,
        }
    },
})
